<template>
  <el-dialog title="调整记录" :visible.sync="jiluMark" :close-on-click-modal="false" width="900px" center append-to-body
    :before-close="closeadd">
    <div class="dialog-table-wrapper">
      <el-table :data="tableDataList" ref="table" bordersize="mini" style="width: 100%" class="tableComent" highlight-current-row center border
      height="400"  >
        <el-table-column prop="oldPredictedAmount" min-width="150" label="原预估收支(万元)"></el-table-column>
        <el-table-column prop="newPredictedAmount" min-width="150" label="新预估收支(万元)"></el-table-column>
         <!-- <el-table-column prop="oldActualAmount" min-width="150" label="原实际收支(万元)"></el-table-column>
        <el-table-column prop="newActualAmount" min-width="150" label="新实际收支(万元)"></el-table-column> -->
        <el-table-column prop="adjustRemark" min-width="250" label="调整备注"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat"  width="170" label="调整时间"></el-table-column>
        <el-table-column prop="createUser" width="150" label="调整人"></el-table-column>

      </el-table>
    </div>
    <div slot="footer">
      <el-button @click="closeadd">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { findPlanAdjustRecordList } from '@/api/common-signature'
import { dateTimeFormat } from '@/utils/util'
export default {
  name: 'monthPlanDialog',
  components: {},
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      tableDataList: []
    }
  },
  props: {
    jiluMark: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    }
  },
  mounted () {

  },
  created () {
    this.detailList()
  },

  methods: {

    detailList () {
      findPlanAdjustRecordList({ detailId: this.rowData.id, sjszTzFlag: 1 })
        .then(res => {
          this.tableDataList = res
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    closeadd () {
      this.$emit('update:jiluMark', false)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
.dialog-table-wrapper {
  // 确保容器不会限制表格
  min-height: 300px;
  max-height: 700px;
  overflow: hidden;
}

// 确保表格滚动正常工作
::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}
</style>
